import { CircularProgress, makeStyles, Typography } from '@material-ui/core';
import { getSkillRelevancyScore } from 'controllers/skillsRecommendation/getSkillRelevancyScore';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useStore } from './context';

const useStyles = makeStyles(() => ({
  scoreCardContainer: {
    backgroundColor: '#ffffff',
    padding: 16,
    height: '100%',
  },
  scoreCardTitle: {
    fontFamily: 'Roboto',
    fontSize: 24,
    fontWeight: 'normal',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    color: 'rgba(0, 0, 0, 0.87)',
    paddingBottom: 9,
  },
  scoreCardSubTitle: {
    fontFamily: 'Roboto',
    fontSize: 13,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.24,
    textAlign: 'left',
    color: '#60676f',
    paddingBottom: 25,
  },
  circularBarContainer: {
    position: 'relative',
    marginBottom: 8,
  },
  circularbarText: {
    fontFamily: 'Roboto',
    fontSize: 34,
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.62,
    textAlign: 'left',
    color: '#49515a',
    position: 'absolute',
    top: '50%',
    left: '46px',
    transform: 'translate(-50%, -50%)',

    '& span': {
      fontSize: 14,
    },
  },
  circularBarMain: {
    zIndex: 10,
    position: 'relative',
  },
  circularBarBg: {
    color: '#ddd',
    position: 'absolute',
    left: 0,
    zIndex: 1,
  },
}));

const SkillsScoreCard = () => {
  const classes = useStyles();
  const [score, setScore] = useState();

  const {
    state: { skillSet1, skillSet2 },
  } = useStore();

  useEffect(() => {
    const fetchSkillScore = async () => {
      const response = await getSkillRelevancyScore(skillSet1, skillSet2);

      setScore(response.skillRelevance || 0);
    };

    if (skillSet1.length > 2 && skillSet2.length > 2) {
      fetchSkillScore();
    } else {
      setScore(0);
    }
  }, [skillSet1, skillSet2]);

  return (
    <div className={classes.scoreCardContainer}>
      <Typography classes={{ root: classes.scoreCardTitle }}>
        Skills Relevancy Score
      </Typography>
      <Typography classes={{ root: classes.scoreCardSubTitle }}>
        Measure the relevance between two set of skills
      </Typography>
      <div className={classes.circularBarContainer}>
        <CircularProgress
          variant="static"
          value={Number(score)}
          size={92}
          thickness={2.7}
          classes={{ root: classes.circularBarMain }}
        />
        <CircularProgress
          variant="static"
          value={100}
          size={92}
          thickness={2.7}
          classes={{ root: classes.circularBarBg }}
        />
        <Typography classes={{ root: classes.circularbarText }}>
          {Math.round(Number(score)) || '00'}
          {Number(score) ? <span>%</span> : null}
        </Typography>
      </div>
    </div>
  );
};

export default SkillsScoreCard;
